import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.pos.sales');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-pos-sales',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.pos.sales/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: hidden;
}

* {
  box-sizing: border-box;
}

.sales-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--pos-bg);
  color: var(--pos-text);
  font-family: "Noto Sans KR", -apple-system, BlinkMacSystemFont, sans-serif;
}

.sales-header {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background: var(--pos-panel);
  border-bottom: 1px solid var(--pos-border);
  flex-shrink: 0;
  box-shadow: var(--pos-shadow);
}
.sales-header .header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.sales-header .back-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid var(--pos-border);
  background: transparent;
  color: var(--pos-text-dim);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 150ms;
  padding: 0;
}
.sales-header .back-btn svg {
  width: 18px;
  height: 18px;
}
.sales-header .back-btn:hover {
  background: var(--pos-card);
  color: var(--pos-text);
}
.sales-header .datetime-area {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.sales-header .date-text {
  font-size: 14px;
  font-weight: 500;
  color: var(--pos-text);
}
.sales-header .datetime-sep {
  font-size: 14px;
  color: var(--pos-text-dim);
}
.sales-header .time-text {
  font-size: 20px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--pos-accent);
  letter-spacing: 1px;
}
.sales-header .header-center {
  flex: 1;
  text-align: center;
}
.sales-header .header-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--pos-text);
}
.sales-header .move-badge {
  display: inline-block;
  margin-left: 12px;
  padding: 3px 12px;
  background: var(--pos-orange);
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}
.sales-body {
  flex: 1;
  display: flex;
  min-height: 0;
  overflow: hidden;
}

.floor-map-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  min-width: 0;
}

.floor-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.floor-title-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.floor-icon {
  width: 20px;
  height: 20px;
  color: var(--pos-accent);
  flex-shrink: 0;
}

.floor-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--pos-text);
}

.floor-stats {
  display: flex;
  gap: 6px;
}

.stat-chip {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 20px;
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
  font-size: 11px;
  color: var(--pos-text-dim);
  transition: all 150ms;
}

.stat-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.dot-empty {
  background: var(--pos-border);
  border: 1px solid var(--pos-text-dim);
}

.dot-occupied {
  background: var(--pos-accent);
  box-shadow: 0 0 4px rgba(59, 130, 246, 0.4);
}

.dot-reserved {
  background: var(--pos-orange);
  box-shadow: 0 0 4px rgba(245, 158, 11, 0.4);
}

.stat-num {
  font-weight: 700;
  font-size: 12px;
  color: var(--pos-text);
  font-variant-numeric: tabular-nums;
}

.stat-label {
  font-weight: 500;
}

.chip-total {
  border-color: var(--pos-text-dim);
}
.chip-total .stat-num {
  color: var(--pos-accent);
}

.floor-map {
  flex: 1;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  min-height: 0;
  background: var(--pos-panel);
  border: 2px solid var(--pos-border);
  box-shadow: inset 0 0 60px rgba(0, 0, 0, 0.02), 0 2px 12px rgba(0, 0, 0, 0.06);
}
.floor-map::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background-image: radial-gradient(circle, var(--pos-border) 1px, transparent 1px);
  background-size: 24px 24px;
  opacity: 0.5;
}
.floor-map.move-active {
  border-color: var(--pos-orange);
  box-shadow: inset 0 0 40px rgba(245, 158, 11, 0.05), 0 0 0 2px rgba(245, 158, 11, 0.2);
}

.zone-bg {
  position: absolute;
  z-index: 1;
  border-radius: 10px;
  border: 1.5px dashed;
  pointer-events: none;
}

.zone-hall {
  left: 1%;
  top: 2%;
  width: 54%;
  height: 62%;
  background: rgba(59, 130, 246, 0.02);
  border-color: rgba(59, 130, 246, 0.15);
}

.zone-room {
  left: 57%;
  top: 2%;
  width: 42%;
  height: 62%;
  background: rgba(139, 92, 246, 0.02);
  border-color: rgba(139, 92, 246, 0.15);
}

.zone-bar {
  left: 1%;
  top: 66%;
  width: 42%;
  height: 32%;
  background: rgba(245, 158, 11, 0.02);
  border-color: rgba(245, 158, 11, 0.15);
}

.zone-terrace {
  left: 57%;
  top: 66%;
  width: 42%;
  height: 32%;
  background: rgba(34, 197, 94, 0.02);
  border-color: rgba(34, 197, 94, 0.15);
}

.zone-tag {
  position: absolute;
  top: 4px;
  left: 6px;
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 2px 8px 2px 5px;
  border-radius: 6px;
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  font-size: 10px;
  font-weight: 600;
  color: var(--pos-text-dim);
  letter-spacing: 0.3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
.zone-tag svg {
  width: 11px;
  height: 11px;
  flex-shrink: 0;
}

.zone-hall .zone-tag {
  color: var(--pos-accent);
  border-color: rgba(59, 130, 246, 0.3);
}

.zone-room .zone-tag {
  color: rgb(139, 92, 246);
  border-color: rgba(139, 92, 246, 0.3);
}

.zone-bar .zone-tag {
  color: var(--pos-orange);
  border-color: rgba(245, 158, 11, 0.3);
}

.zone-terrace .zone-tag {
  color: var(--pos-green);
  border-color: rgba(34, 197, 94, 0.3);
}

.kitchen-area {
  position: absolute;
  z-index: 2;
  top: -2px;
  left: 0;
  width: 30%;
  height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 5px 0;
  border-bottom: 2px solid var(--pos-text-dim);
  pointer-events: none;
}
.kitchen-area::before {
  content: "";
  position: absolute;
  top: -16px;
  left: 0;
  width: 100%;
  height: 16px;
  background: repeating-linear-gradient(-45deg, transparent, transparent 4px, var(--pos-border) 4px, var(--pos-border) 5px);
  border-radius: 10px 10px 0 0;
  opacity: 0.6;
}
.kitchen-area svg {
  width: 12px;
  height: 12px;
  color: var(--pos-text-dim);
  opacity: 0.7;
  position: relative;
  top: -10px;
}
.kitchen-area span {
  position: relative;
  top: -10px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 2px;
  color: var(--pos-text-dim);
  opacity: 0.6;
  text-transform: uppercase;
}

.counter-bar-deco {
  position: absolute;
  z-index: 2;
  left: 2%;
  top: 72%;
  width: 38%;
  height: 2px;
  background: linear-gradient(90deg, var(--pos-orange), rgba(245, 158, 11, 0.2));
  border-radius: 1px;
  pointer-events: none;
}
.counter-bar-deco::before {
  content: "";
  position: absolute;
  left: 0;
  top: -4px;
  width: 100%;
  height: 10px;
  background: linear-gradient(180deg, rgba(245, 158, 11, 0.06), transparent);
}

.table-card {
  position: absolute;
  z-index: 5;
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  overflow: hidden;
  background: var(--pos-panel);
  cursor: pointer;
  user-select: none;
  transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  border: 1.5px solid var(--pos-border);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.table-card:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 10;
}
.table-card:active {
  transform: scale(0.98);
}

.card-stripe {
  width: 4px;
  flex-shrink: 0;
  transition: background 200ms;
}

.status-empty .card-stripe {
  background: var(--pos-border);
}

.status-occupied .card-stripe {
  background: linear-gradient(180deg, var(--pos-accent), #60a5fa);
  box-shadow: 1px 0 8px rgba(59, 130, 246, 0.3);
}

.status-reserved .card-stripe {
  background: linear-gradient(180deg, var(--pos-orange), #fbbf24);
  box-shadow: 1px 0 8px rgba(245, 158, 11, 0.3);
}

.card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px 6px;
  gap: 1px;
  min-width: 0;
}

.card-id {
  font-size: 16px;
  font-weight: 800;
  color: var(--pos-text);
  letter-spacing: 0.5px;
  line-height: 1.2;
}

.card-seats {
  display: flex;
  align-items: center;
  gap: 2px;
}
.card-seats svg {
  width: 10px;
  height: 10px;
  color: var(--pos-text-dim);
}
.card-seats span {
  font-size: 10px;
  font-weight: 600;
  color: var(--pos-text-dim);
}

.card-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  width: 100%;
}

.card-status {
  font-size: 8px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 3px;
  line-height: 1.4;
  color: var(--pos-text-dim);
  background: var(--pos-card);
}

.card-amount {
  font-size: 9px;
  font-weight: 700;
  color: var(--pos-accent);
  letter-spacing: -0.3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.status-empty {
  background: var(--pos-panel);
  border-color: var(--pos-border);
}
.status-empty .card-id {
  color: var(--pos-text-dim);
}

.status-occupied {
  background: linear-gradient(135deg, var(--pos-panel) 0%, rgba(59, 130, 246, 0.04) 100%);
  border-color: rgba(59, 130, 246, 0.3);
}
.status-occupied .card-status {
  color: #fff;
  background: var(--pos-accent);
}

.status-reserved {
  background: linear-gradient(135deg, var(--pos-panel) 0%, rgba(245, 158, 11, 0.04) 100%);
  border-color: rgba(245, 158, 11, 0.3);
}
.status-reserved .card-status {
  color: #fff;
  background: var(--pos-orange);
}

.is-selected {
  border-color: var(--pos-accent) !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25), 0 8px 24px rgba(59, 130, 246, 0.2) !important;
  z-index: 20 !important;
}

.is-move-source {
  border-color: var(--pos-orange) !important;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.3), 0 8px 24px rgba(245, 158, 11, 0.2) !important;
  z-index: 20 !important;
  animation: move-glow 1.5s ease-in-out infinite;
}

@keyframes move-glow {
  0%, 100% {
    box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.3), 0 8px 24px rgba(245, 158, 11, 0.2);
  }
  50% {
    box-shadow: 0 0 0 5px rgba(245, 158, 11, 0.4), 0 8px 32px rgba(245, 158, 11, 0.3);
  }
}
.shape-round {
  border-radius: 50%;
}
.shape-round .card-stripe {
  display: none;
}
.shape-round .card-body {
  padding: 4px 3px;
  gap: 2px;
}
.shape-round .card-id {
  font-size: 14px;
}
.shape-round .card-seats {
  display: none;
}
.shape-round .card-bottom {
  display: flex;
  gap: 2px;
}
.shape-round .card-status {
  font-size: 7px;
  padding: 1px 5px;
}
.shape-round .card-amount {
  font-size: 8px;
  max-width: calc(100% - 4px);
}

.shape-round.status-empty {
  border: 2px dashed var(--pos-border);
  background: var(--pos-card);
}

.shape-round.status-occupied {
  border: 2px solid rgba(59, 130, 246, 0.4);
  background: radial-gradient(circle, rgba(59, 130, 246, 0.06) 0%, var(--pos-panel) 100%);
  box-shadow: 0 0 12px rgba(59, 130, 246, 0.1);
}

.shape-round.status-reserved {
  border: 2px solid rgba(245, 158, 11, 0.4);
  background: radial-gradient(circle, rgba(245, 158, 11, 0.06) 0%, var(--pos-panel) 100%);
}

.shape-wide {
  border-radius: 12px;
}
.shape-wide .card-body {
  flex-direction: row;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 6px 12px;
}
.shape-wide .card-id {
  font-size: 18px;
}
.shape-wide .card-bottom {
  flex-direction: row;
  gap: 6px;
  width: auto;
}
.shape-wide .card-seats {
  order: -1;
}

.shape-bar {
  border-radius: 50%;
}
.shape-bar .card-stripe {
  display: none;
}
.shape-bar .card-body {
  padding: 2px;
}
.shape-bar .card-id {
  font-size: 12px;
  font-weight: 700;
}
.shape-bar .card-seats {
  display: none;
}
.shape-bar .card-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  padding: 0 2px;
}
.shape-bar .card-status {
  font-size: 7px;
}
.shape-bar .card-amount {
  font-size: 7px;
}
.shape-bar::after {
  content: "";
  position: absolute;
  top: -4px;
  left: 25%;
  width: 50%;
  height: 4px;
  background: var(--pos-text-dim);
  border-radius: 4px 4px 0 0;
  opacity: 0.3;
}

.shape-bar.status-occupied {
  border-color: rgba(59, 130, 246, 0.4);
  background: radial-gradient(circle, rgba(59, 130, 246, 0.08) 0%, var(--pos-panel) 100%);
}
.shape-bar.status-occupied::after {
  background: var(--pos-accent);
  opacity: 0.6;
}

.entrance-marker {
  position: absolute;
  z-index: 3;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 0;
  width: 50%;
  pointer-events: none;
}

.entrance-line-l, .entrance-line-r {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--pos-text-dim));
  opacity: 0.3;
}

.entrance-line-r {
  background: linear-gradient(90deg, var(--pos-text-dim), transparent);
}

.entrance-gate {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 12px;
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.entrance-gate svg {
  width: 12px;
  height: 12px;
  color: var(--pos-text-dim);
}
.entrance-gate span {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 2px;
  color: var(--pos-text-dim);
  text-transform: uppercase;
}

.table-action-bar {
  flex-shrink: 0;
  margin-top: 10px;
  padding: 10px 14px;
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  animation: slideUp 200ms ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.ta-info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.ta-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--pos-text);
}

.ta-badge {
  font-size: 11px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 4px;
}

.badge-empty {
  color: var(--pos-text-dim);
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
}

.badge-occupied {
  color: #fff;
  background: var(--pos-accent);
}

.badge-reserved {
  color: #fff;
  background: var(--pos-orange);
}

.ta-seats {
  font-size: 12px;
  color: var(--pos-text-dim);
}

.ta-amount {
  font-size: 13px;
  font-weight: 600;
  color: var(--pos-accent);
}

.ta-buttons {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.ta-btn {
  padding: 7px 16px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 150ms;
}
.ta-btn:hover {
  transform: scale(1.03);
}
.ta-btn:active {
  transform: scale(0.97);
}
.ta-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.ta-btn:disabled:hover {
  transform: none;
}

.ta-order {
  background: var(--pos-accent);
  color: #fff;
  border-color: var(--pos-accent);
}
.ta-order:hover {
  background: var(--pos-accent-hover, #2563eb);
}

.ta-pay {
  background: var(--pos-green);
  color: #fff;
  border-color: var(--pos-green);
}
.ta-pay:hover {
  opacity: 0.9;
}

.ta-kitchen {
  background: var(--pos-orange);
  color: #fff;
  border-color: var(--pos-orange);
}
.ta-kitchen:hover {
  opacity: 0.9;
}

.ta-move:hover {
  background: var(--pos-border);
}

.ta-cancel {
  background: var(--pos-red);
  color: #fff;
  border-color: var(--pos-red);
}
.ta-cancel:hover {
  opacity: 0.9;
}

.move-bar {
  border-color: var(--pos-orange);
}

.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: var(--pos-modal-backdrop, rgba(0, 0, 0, 0.3));
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-overlay {
  z-index: 1100;
}

.modal-box {
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  max-height: 92vh;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
}

.modal-sm {
  width: 90%;
  max-width: 400px;
}

.modal-lg {
  width: 92%;
  max-width: 860px;
}

.modal-xl {
  width: 95%;
  max-width: 1060px;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--pos-border);
}
.modal-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

.close-btn {
  width: 28px;
  height: 28px;
  border-radius: var(--pos-radius, 6px);
  border: 1px solid var(--pos-border);
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.close-btn:hover {
  background: var(--pos-card);
  color: var(--pos-text);
}

.modal-body {
  flex: 1;
  padding: 14px 16px;
  overflow: auto;
  font-size: 13px;
}
.modal-body.text-center {
  text-align: center;
  padding: 28px 16px;
}
.modal-body.no-pad {
  padding: 0;
}
.modal-body .msg {
  font-size: 14px;
  line-height: 1.6;
}

.modal-footer {
  padding: 10px 16px;
  border-top: 1px solid var(--pos-border);
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.modal-btn {
  padding: 7px 18px;
  border-radius: 6px;
  border: none;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.modal-btn.primary {
  background: var(--pos-accent);
  color: #fff;
}
.modal-btn.primary:hover {
  background: var(--pos-accent-hover, #2563eb);
}
.modal-btn.outline {
  background: transparent;
  border: 1px solid var(--pos-border);
  color: var(--pos-text-dim);
}
.modal-btn.outline:hover {
  background: var(--pos-card);
  color: var(--pos-text);
}
.modal-btn.danger {
  background: var(--pos-red);
  color: #fff;
}
.modal-btn.danger:hover {
  opacity: 0.85;
}
.modal-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.order-layout {
  display: flex;
  height: 520px;
}

.order-menu {
  flex: 1;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--pos-border);
  min-width: 0;
}

.menu-cat-bar {
  display: flex;
  gap: 0;
  border-bottom: 1px solid var(--pos-border);
  flex-shrink: 0;
}

.cat-btn {
  flex: 1;
  padding: 10px 8px;
  border: none;
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 150ms;
  border-bottom: 2px solid transparent;
}
.cat-btn.active {
  color: var(--pos-accent);
  border-bottom-color: var(--pos-accent);
  font-weight: 600;
  background: rgba(59, 130, 246, 0.04);
}
.cat-btn:hover {
  background: var(--pos-card);
}

.menu-grid {
  flex: 1;
  overflow: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 12px;
  align-content: start;
}

.menu-item-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 14px 8px;
  border-radius: 8px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  cursor: pointer;
  transition: all 150ms;
}
.menu-item-btn:hover {
  background: var(--pos-accent);
  color: #fff;
  border-color: var(--pos-accent);
}
.menu-item-btn:hover .mi-price {
  color: rgba(255, 255, 255, 0.8);
}
.menu-item-btn:active {
  transform: scale(0.96);
}

.mi-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--pos-text);
  text-align: center;
}

.mi-price {
  font-size: 11px;
  color: var(--pos-text-dim);
}

.menu-item-btn:hover .mi-name {
  color: #fff;
}

.order-cart {
  width: 300px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}
.order-cart h4 {
  margin: 0;
  padding: 12px 14px;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid var(--pos-border);
}

.cart-list {
  flex: 1;
  overflow: auto;
  padding: 8px 10px;
}

.cart-empty {
  text-align: center;
  padding: 40px 0;
  color: var(--pos-text-dim);
  font-size: 13px;
}

.cart-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 6px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}
.cart-item:last-child {
  border-bottom: none;
}

.ci-info {
  flex: 1;
  min-width: 0;
}

.ci-name {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: var(--pos-text);
}

.ci-price {
  font-size: 11px;
  color: var(--pos-text-dim);
}

.ci-qty {
  display: flex;
  align-items: center;
  gap: 4px;
}

.qty-btn {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qty-btn:hover {
  background: var(--pos-border);
}

.qty-num {
  min-width: 20px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
}

.ci-del {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ci-del:hover {
  color: var(--pos-red);
  background: rgba(239, 68, 68, 0.08);
}

.cart-footer {
  border-top: 1px solid var(--pos-border);
  padding: 10px 14px;
}

.cart-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
}

.total-amount {
  color: var(--pos-accent);
  font-size: 18px;
}

.cart-actions {
  display: flex;
  gap: 6px;
  justify-content: flex-end;
}

.payment-layout {
  display: flex;
  height: 560px;
}

.pay-order-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--pos-border);
  min-width: 0;
}

.pay-panel-head, .pay-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 44px;
  padding: 0 14px;
  border-bottom: 1px solid var(--pos-border);
}
.pay-panel-head h4, .pay-section-head h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 800;
  color: var(--pos-text);
}
.pay-panel-head span, .pay-section-head span {
  font-size: 12px;
  font-weight: 800;
  color: var(--pos-text-dim);
}

.pay-items {
  flex: 1;
  overflow: auto;
  padding: 8px 10px;
}

.pay-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 8px 8px;
  border-bottom: 1px solid var(--pos-border);
}

.pi-info {
  flex: 1;
  min-width: 0;
}

.pi-name {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: var(--pos-text);
}

.pi-price {
  font-size: 11px;
  color: var(--pos-text-dim);
}

.pi-qty {
  display: flex;
  align-items: center;
  gap: 4px;
}

.pi-del {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pi-del:hover {
  color: var(--pos-red);
  background: rgba(239, 68, 68, 0.08);
}

.pay-total-bar {
  flex-shrink: 0;
  padding: 12px 14px;
  border-top: 1px solid var(--pos-border);
  background: var(--pos-card);
  display: grid;
  gap: 5px;
  font-size: 14px;
  font-weight: 600;
}

.pay-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--pos-text-dim);
}

.pay-total-row.final {
  color: var(--pos-text);
  padding-top: 5px;
  border-top: 1px solid var(--pos-border);
}

.discount-amount {
  color: var(--pos-red);
}

.pay-total-amount {
  font-size: 20px;
  color: var(--pos-accent);
}

.pay-methods {
  width: 400px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 10px;
}

.pay-side-scroll {
  display: grid;
  gap: 10px;
  overflow: auto;
  flex: 1;
  min-height: 0;
}

.pay-section {
  border: 1px solid var(--pos-border);
  border-radius: var(--pos-radius);
  background: var(--pos-panel);
  overflow: hidden;
}

.pay-section-head {
  min-height: 38px;
  padding: 0 12px;
  background: var(--pos-card);
}

.pay-method-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  padding: 10px;
}

.pm-btn {
  display: grid;
  grid-template-columns: 32px 1fr;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 0 10px;
  border-radius: var(--pos-radius-sm);
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  cursor: pointer;
  transition: all 150ms;
}
.pm-btn:hover {
  border-color: var(--pos-accent);
}
.pm-btn.active {
  border-color: var(--pos-accent);
  background: var(--pos-info-bg);
  box-shadow: inset 3px 0 0 var(--pos-accent);
}
.pm-btn span:last-child {
  font-size: 13px;
  font-weight: 800;
  text-align: left;
}

.pm-icon, .pm-brand {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--pos-panel);
  color: var(--pos-accent);
  border: 1px solid var(--pos-border);
}
.pm-icon svg, .pm-brand svg {
  width: 18px;
  height: 18px;
}

.pm-brand {
  font-size: 13px;
  font-weight: 900;
  border: none;
}

.pm-brand.kakao {
  background: #fee500;
  color: #191600;
}

.pm-brand.naver {
  background: #03c75a;
  color: #fff;
}

.pm-kakao.active {
  border-color: #d8bc00;
  background: rgba(254, 229, 0, 0.12);
  box-shadow: inset 3px 0 0 #d8bc00;
}

.pm-naver.active {
  border-color: #03c75a;
  background: rgba(3, 199, 90, 0.12);
  box-shadow: inset 3px 0 0 #03c75a;
}

.discount-box, .split-box {
  padding: 10px;
  background: transparent;
  border: 0;
  border-bottom: 1px solid var(--pos-border);
  margin-bottom: 0;
}

.split-box {
  border-bottom: 0;
}

.discount-row, .split-entry {
  display: grid;
  grid-template-columns: 48px 1fr 1fr;
  gap: 8px;
  align-items: center;
}
.discount-row label, .discount-row span, .split-entry label, .split-entry span {
  color: var(--pos-text-dim);
  font-size: 12px;
  font-weight: 600;
}
.discount-row input, .discount-row select, .split-entry input, .split-entry select {
  height: 32px;
  border: 1px solid var(--pos-border);
  border-radius: var(--pos-radius-sm);
  background: var(--pos-input-bg);
  color: var(--pos-text);
  padding: 0 8px;
  min-width: 0;
}

.discount-preview {
  margin-top: 7px;
  color: var(--pos-red);
  font-size: 12px;
  font-weight: 700;
  text-align: right;
}

.split-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 12px;
  color: var(--pos-text-dim);
  font-weight: 700;
}

.split-entry {
  grid-template-columns: 1fr 1fr auto;
}

.split-list {
  display: grid;
  gap: 5px;
  margin-top: 8px;
}

.split-item {
  display: grid;
  grid-template-columns: 1fr auto 24px;
  align-items: center;
  gap: 8px;
  min-height: 28px;
  padding: 0 8px;
  border-radius: 4px;
  background: var(--pos-panel);
  font-size: 12px;
}
.split-item button {
  border: none;
  background: transparent;
  color: var(--pos-red);
  cursor: pointer;
  font-size: 16px;
}

.cash-detail {
  padding: 12px;
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
  border-radius: var(--pos-radius);
  margin-bottom: 0;
}

.cd-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.cd-row label {
  width: 72px;
  font-size: 12px;
  color: var(--pos-text-dim);
  text-align: right;
  flex-shrink: 0;
}
.cd-row input {
  flex: 1;
  height: 34px;
  padding: 0 10px;
  background: var(--pos-input-bg);
  border: 1px solid var(--pos-border);
  border-radius: 4px;
  color: var(--pos-text);
  font-size: 14px;
  font-weight: 600;
  text-align: right;
  outline: none;
}
.cd-row input:focus {
  border-color: var(--pos-accent);
}

.cash-presets {
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
  padding-left: 80px;
}

.cp-btn {
  padding: 4px 10px;
  border-radius: 4px;
  border: 1px solid var(--pos-border);
  background: var(--pos-panel);
  color: var(--pos-text-dim);
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
}
.cp-btn:hover {
  background: var(--pos-accent);
  color: #fff;
  border-color: var(--pos-accent);
}

.change-row .change-amount {
  flex: 1;
  font-size: 18px;
  font-weight: 700;
  color: var(--pos-green);
  text-align: right;
}

.receipt-section {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--pos-border);
}

.receipt-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--pos-text);
  margin-bottom: 8px;
}

.receipt-options {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--pos-text-dim);
  cursor: pointer;
}
.radio-item input {
  accent-color: var(--pos-accent);
}

.receipt-num-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}
.receipt-num-row label {
  width: 80px;
  font-size: 12px;
  color: var(--pos-text-dim);
  text-align: right;
  flex-shrink: 0;
}
.receipt-num-row input {
  flex: 1;
  height: 30px;
  padding: 0 8px;
  background: var(--pos-input-bg);
  border: 1px solid var(--pos-border);
  border-radius: 4px;
  color: var(--pos-text);
  font-size: 12px;
  outline: none;
}
.receipt-num-row input:focus {
  border-color: var(--pos-accent);
}

.card-detail {
  padding: 22px 12px;
  text-align: center;
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
  border-radius: var(--pos-radius);
}
.card-detail .card-msg .card-icon {
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  color: var(--pos-accent);
  border-radius: 12px;
  background: var(--pos-info-bg);
}
.card-detail .card-msg .card-icon svg {
  width: 30px;
  height: 30px;
}
.card-detail .card-msg p {
  margin: 4px 0;
  font-size: 14px;
  color: var(--pos-text-dim);
}
.card-detail .card-msg .card-amount {
  font-size: 22px;
  font-weight: 800;
  color: var(--pos-accent);
}

.installment-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 8px;
}
.installment-row .installment-label {
  font-size: 13px;
  color: var(--pos-text-dim);
  font-weight: 500;
}
.installment-row .installment-select {
  height: 36px;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid var(--pos-border);
  border-radius: 6px;
  background: var(--pos-panel);
  color: var(--pos-text);
}
.installment-row .installment-select:focus {
  border-color: var(--pos-accent);
  outline: none;
}

.pay-actions {
  margin-top: auto;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 2px;
}

.pay-complete-btn {
  padding: 10px 24px;
  font-size: 14px;
}

.qr-content {
  padding: 10px 0;
}

.qr-placeholder {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.qr-fake {
  width: 160px;
  height: 160px;
  padding: 12px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  align-items: center;
}

.qr-row {
  display: flex;
  gap: 2px;
}

.qr-cell {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  background: #e5e7eb;
}
.qr-cell.filled {
  background: #1f2937;
}

.qr-msg {
  font-size: 14px;
  font-weight: 500;
  color: var(--pos-text);
  margin: 0 0 6px;
}

.qr-amount {
  font-size: 18px;
  font-weight: 700;
  color: var(--pos-accent);
  margin: 0;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 5px;
}
.field-row label {
  width: 68px;
  font-size: 12px;
  color: var(--pos-text-dim);
  flex-shrink: 0;
  text-align: right;
}
.field-row input, .field-row select {
  flex: 1;
  height: 30px;
  padding: 0 8px;
  background: var(--pos-input-bg, #f0f2f5);
  border: 1px solid var(--pos-border);
  border-radius: 4px;
  color: var(--pos-text);
  font-size: 12px;
  outline: none;
}
.field-row input:focus, .field-row select:focus {
  border-color: var(--pos-accent);
}
.field-row select {
  padding-right: 4px;
}

.table-wrap {
  overflow: auto;
  flex: 1;
  min-height: 0;
}

.pos-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.pos-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}
.pos-table thead th {
  padding: 7px 6px;
  background: var(--pos-table-header, #f0f2f5);
  border-bottom: 1px solid var(--pos-border);
  color: var(--pos-text-dim);
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
}
.pos-table tbody tr {
  cursor: pointer;
  transition: background 100ms;
}
.pos-table tbody tr:hover {
  background: var(--pos-hover, rgba(59, 130, 246, 0.06));
}
.pos-table tbody tr.selected {
  background: var(--pos-selected, rgba(59, 130, 246, 0.12));
}
.pos-table tbody tr td {
  padding: 6px;
  border-bottom: 1px solid var(--pos-border);
  border-bottom-color: rgba(0, 0, 0, 0.04);
  text-align: center;
  white-space: nowrap;
}
.pos-table .text-right {
  text-align: right;
}
.pos-table .text-center {
  text-align: center;
}

.os-search {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}
.os-search .os-fields {
  flex: 1;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.os-search .os-fields .field-row {
  flex: 1;
  min-width: 180px;
}
.os-search .os-btns {
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: flex-end;
}

.os-tables {
  display: flex;
  gap: 10px;
  min-height: 260px;
}
.os-tables .os-left, .os-tables .os-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.os-tables .os-left h4, .os-tables .os-right h4 {
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--pos-text-dim);
}
.os-tables .os-left .table-wrap, .os-tables .os-right .table-wrap {
  flex: 1;
  border: 1px solid var(--pos-border);
  border-radius: 4px;
  overflow: auto;
}

.wl-content {
  display: flex;
  gap: 12px;
  min-height: 340px;
}

.wl-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.wl-left .table-wrap {
  flex: 1;
  border: 1px solid var(--pos-border);
  border-radius: 4px;
  margin-bottom: 10px;
  overflow: auto;
}

.wl-input {
  display: flex;
  gap: 10px;
}
.wl-input .wl-fields {
  flex: 1;
}
.wl-input .wl-actions {
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: flex-end;
}

.wl-keypad {
  width: 180px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.rv-content {
  display: flex;
  gap: 12px;
  min-height: 380px;
}

.rv-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.rv-left .rv-filters {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}
.rv-left .rv-date-range {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}
.rv-left .rv-date-range input {
  height: 28px;
  padding: 0 6px;
  background: var(--pos-input-bg);
  border: 1px solid var(--pos-border);
  border-radius: 4px;
  color: var(--pos-text);
  font-size: 12px;
}
.rv-left .rv-date-range span {
  color: var(--pos-text-dim);
  font-size: 12px;
}
.rv-left .rv-table-search {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.rv-left .rv-table-search label {
  font-size: 12px;
  color: var(--pos-text-dim);
}
.rv-left .rv-table-search input {
  flex: 1;
  height: 28px;
  padding: 0 8px;
  background: var(--pos-input-bg);
  border: 1px solid var(--pos-border);
  border-radius: 4px;
  color: var(--pos-text);
  font-size: 12px;
}
.rv-left .table-wrap {
  flex: 1;
  border: 1px solid var(--pos-border);
  border-radius: 4px;
  overflow: auto;
}

.ck {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--pos-text-dim);
  cursor: pointer;
}
.ck input {
  accent-color: var(--pos-accent);
}

.rv-right {
  width: 280px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rv-form h4 {
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 600;
}
.rv-form .datetime-row {
  display: flex;
  gap: 6px;
  flex: 1;
}
.rv-form .datetime-row input {
  flex: 1;
  height: 30px;
  padding: 0 6px;
  background: var(--pos-input-bg);
  border: 1px solid var(--pos-border);
  border-radius: 4px;
  color: var(--pos-text);
  font-size: 12px;
}
.rv-form .rv-form-actions {
  display: flex;
  gap: 5px;
  margin-top: 6px;
  flex-wrap: wrap;
}

.rv-keypad {
  display: flex;
  flex-direction: column;
}

.kp-display {
  background: var(--pos-keypad-display, var(--pos-input-bg));
  border: 1px solid var(--pos-border);
  border-radius: 4px;
  padding: 6px 10px;
  margin-bottom: 6px;
  text-align: right;
  font-size: 18px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: var(--pos-text);
}

.kp-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
}

.kp-btn {
  padding: 10px 4px;
  border-radius: 4px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.kp-btn:hover {
  background: var(--pos-border);
}
.kp-btn:active {
  transform: scale(0.95);
}

.kp-c {
  color: var(--pos-red);
}

.kp-enter {
  grid-column: span 2;
  background: var(--pos-accent);
  color: #fff;
  font-weight: 600;
}
.kp-enter:hover {
  background: var(--pos-accent-hover, #2563eb);
}

.unclosed-overlay {
  z-index: 2000;
}

.unclosed-box .unclosed-header {
  gap: 10px;
  flex-direction: row;
  justify-content: flex-start;
}

.unclosed-icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(245, 158, 11, 0.12);
  border-radius: 8px;
}
.unclosed-icon svg {
  width: 20px;
  height: 20px;
  stroke: var(--pos-orange);
}

.unclosed-msg {
  padding: 8px 0;
}
.unclosed-msg p {
  margin: 0;
  font-size: 14px;
  line-height: 1.8;
  color: var(--pos-text);
}
.unclosed-msg strong {
  color: var(--pos-red);
  font-weight: 700;
}

.opening-overlay {
  z-index: 2000;
}

.opening-box {
  width: 780px;
}

.opening-layout {
  display: flex;
  min-height: 400px;
}

.opening-left {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-right: 1px solid var(--pos-border);
}

.opening-section {
  background: var(--pos-card);
  border-radius: 8px;
  padding: 14px 16px;
  border: 1px solid var(--pos-border);
}

.opening-section-title {
  margin: 0 0 12px;
  font-size: 13px;
  font-weight: 700;
  color: var(--pos-accent);
  padding-bottom: 8px;
  border-bottom: 1px solid var(--pos-border);
}

.opening-info-table {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.info-row .info-label {
  width: 100px;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--pos-text-dim);
  text-align: right;
}
.info-row .info-value {
  flex: 1;
  font-size: 13px;
  font-weight: 500;
  color: var(--pos-text);
  padding: 4px 8px;
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: 4px;
}
.info-row .info-value.accent {
  color: var(--pos-accent);
  font-weight: 700;
}

.opening-right {
  width: 260px;
  flex-shrink: 0;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.opening-kp-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--pos-accent);
  letter-spacing: 0.3px;
  text-align: center;
}

.opening-kp-display {
  background: var(--pos-keypad-display, var(--pos-input-bg));
  border: 1px solid var(--pos-border);
  border-radius: 6px;
  padding: 8px 12px;
  text-align: right;
  font-size: 20px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--pos-text);
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.opening-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.opening-actions button {
  flex: 1;
  padding: 10px 8px;
  font-size: 13px;
  font-weight: 600;
}`],
})
export class PagePosSalesComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) {}

    // ─── 시계 ───
    public currentDate = '';
    public currentTime = '';
    private clockInterval: any;

    // ─── 모달 상태 ───
    public activeModal = '';

    // ─── 영업관리 상태 ───
    public showUnclosedWarning = false;
    public unclosedDate = '';
    public showOpeningModal = false;

    // 개점처리 모달 데이터
    public lastCloseDate = '';
    public lastCloseTime = '';
    public lastCloseSeller = '';
    public openSystemDate = '';
    public openBusinessDate = '';
    public openSeller = '';
    public openCash = '';
    public openKeypad = '';

    // ─── 테이블 데이터 (DB에서 로드) ───
    public tables: any[] = [];
    public selectedTable: any = null;
    public tableOrders: { [id: number]: { orderId: string; items: { menuId: number; name: string; price: number; qty: number }[] } } = {};

    get emptyCount() { return this.tables.filter(t => t.status === 'empty').length; }
    get occupiedCount() { return this.tables.filter(t => t.status === 'occupied').length; }
    get reservedCount() { return this.tables.filter(t => t.status === 'reserved').length; }
    get totalTables() { return this.tables.length; }

    public moveMode = false;
    public moveSourceTable: any = null;

    // ─── 메뉴 (DB에서 로드) ───
    public menuCategories: any[] = [];
    public allMenuItems: any[] = [];

    public orderCategory = '';
    public orderCart: { menuId: number; name: string; price: number; qty: number }[] = [];
    public orderTableId = 0;

    get filteredMenuItems() {
        return this.allMenuItems.filter(m => m.category === this.orderCategory);
    }

    get orderTotal() {
        return this.orderCart.reduce((s, i) => s + i.price * i.qty, 0);
    }

    public paymentItems: { menuId: number; name: string; price: number; qty: number }[] = [];
    public paymentTableId = 0;
    public paymentMethod = '';
    public cashReceived = '';
    public receiptType = 'none';
    public receiptNumber = '';
    public showQrModal = false;
    public qrPaymentName = '';
    public isProcessing = false;
    public installmentMonths = '0';
    public discountType = 'none';
    public discountValue = '';
    public splitMethod = 'cash';
    public splitAmount = '';
    public splitPayments: { method: string; amount: number }[] = [];
    public confirmMerge = false;
    public mergeTargetTable: any = null;

    get paymentSubtotal() {
        return this.paymentItems.reduce((s, i) => s + i.price * i.qty, 0);
    }

    get paymentDiscountAmount() {
        const value = parseInt(this.discountValue) || 0;
        if (this.discountType === 'percent') return Math.floor(this.paymentSubtotal * Math.min(value, 100) / 100);
        if (this.discountType === 'amount') return Math.min(value, this.paymentSubtotal);
        return 0;
    }

    get paymentTotal() {
        return Math.max(0, this.paymentSubtotal - this.paymentDiscountAmount);
    }

    get cashChange() {
        const received = parseInt(this.cashReceived) || 0;
        return Math.max(0, received - this.paymentTotal);
    }

    get splitTotal() {
        return this.splitPayments.reduce((s, p) => s + (Number(p.amount) || 0), 0);
    }

    get splitRemain() {
        return Math.max(0, this.paymentTotal - this.splitTotal);
    }

    public osDate = '';
    public osPosNo = '';
    public osTable = '';
    public osOrders: any[] = [];
    public osSelectedIdx = -1;
    public osDetails: any[] = [];
    public lastReceiptMsg = '';

    public waitListData: any[] = [];
    public wlSelectedIdx = -1;
    public wlName = ''; public wlPhone = ''; public wlCount = ''; public wlNote = ''; public wlKeypad = '';

    public rvFilterDate = true; public rvFilterName = false; public rvFilterPhone = false; public rvFilterCancelled = false;
    public rvStartDate = ''; public rvEndDate = ''; public rvTableSearch = '';
    public rvList: any[] = [];
    public rvSelectedIdx = -1;
    public rvDate = ''; public rvTime = ''; public rvName = ''; public rvPhone = '';
    public rvCount = ''; public rvTable = ''; public rvMemo = ''; public rvKeypad = '';

    // ═══════ Lifecycle ═══════
    private menuActionHandler: any;

    public async ngOnInit() {
        await this.service.init();
        this.menuActionHandler = (e: any) => { this.handleMenuAction(e.detail.action); };
        document.addEventListener('pos-menu-action', this.menuActionHandler);
        this.updateClock();
        this.clockInterval = setInterval(() => { this.updateClock(); this.service.render(); }, 1000);

        // DB에서 데이터 로드
        await this.loadTables();
        await this.loadMenu();
        await this.loadOrders();

        // 영업일자 체크
        await this.checkBusinessDay();

        await this.service.render();
    }

    ngOnDestroy() {
        if (this.clockInterval) clearInterval(this.clockInterval);
        if (this.menuActionHandler) document.removeEventListener('pos-menu-action', this.menuActionHandler);
    }

    private updateClock() {
        const now = new Date();
        const y = now.getFullYear(), m = String(now.getMonth() + 1).padStart(2, '0'), d = String(now.getDate()).padStart(2, '0');
        const days = ['일', '월', '화', '수', '목', '금', '토'];
        const day = days[now.getDay()];
        const h = String(now.getHours()).padStart(2, '0'), min = String(now.getMinutes()).padStart(2, '0'), s = String(now.getSeconds()).padStart(2, '0');
        this.currentDate = `${y}.${m}.${d} (${day})`;
        this.currentTime = `${h}:${min}:${s}`;
    }

    // ═══════ DB 데이터 로드 ═══════
    private async loadTables() {
        let res = await wiz.call("load_tables");
        if (res.code === 200) {
            this.tables = res.data.tables;
        }
    }

    private async loadMenu() {
        let res = await wiz.call("load_menu");
        if (res.code === 200) {
            this.menuCategories = res.data.categories;
            this.allMenuItems = res.data.menus;
            if (this.menuCategories.length > 0) {
                this.orderCategory = this.menuCategories[0].id;
            }
        }
    }

    private async loadOrders() {
        let res = await wiz.call("load_orders");
        if (res.code === 200) {
            this.tableOrders = res.data.orders || {};
        }
    }

    // ═══════ 영업일자 체크 ═══════
    private getTodayStr(): string {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    }

    private async checkBusinessDay() {
        const today = this.getTodayStr();
        let res = await wiz.call("get_business_day");
        const bd = res.code === 200 ? res.data.data : null;

        if (bd) {
            if (bd.date && bd.date !== today) {
                if (!bd.closed) {
                    this.unclosedDate = bd.date;
                    this.showUnclosedWarning = true;
                    return;
                } else {
                    this.prepareOpeningModal(bd);
                    this.showOpeningModal = true;
                    return;
                }
            }
            if (bd.closed) {
                this.prepareOpeningModal(bd);
                this.showOpeningModal = true;
                return;
            }
            return;
        }

        // 영업일 없음 → 최초 개점 필요
        this.lastCloseDate = '-';
        this.lastCloseTime = '-';
        this.lastCloseSeller = '-';
        this.openSystemDate = today;
        this.openBusinessDate = today;
        const auth = this.getAuthInfo();
        this.openSeller = auth ? `${auth.id} - ${auth.name}` : '-';
        this.openCash = '';
        this.openKeypad = '';
        this.showOpeningModal = true;
    }

    private prepareOpeningModal(bd: any) {
        const today = this.getTodayStr();
        this.lastCloseDate = bd.closed_at ? bd.date : bd.date || '-';
        this.lastCloseTime = bd.closed_at || '-';
        this.lastCloseSeller = bd.closed_by || '-';
        this.openSystemDate = today;
        this.openBusinessDate = today;
        const auth = this.getAuthInfo();
        this.openSeller = auth ? `${auth.id} - ${auth.name}` : '-';
        this.openCash = '';
        this.openKeypad = '';
    }

    private getAuthInfo(): { id: string; name: string } | null {
        try {
            const raw = localStorage.getItem('pos-auth');
            if (raw) return JSON.parse(raw);
        } catch (e) { }
        return null;
    }

    public async closeWarningModal() {
        this.showUnclosedWarning = false;
        await this.service.render();
    }

    public async openOnKey(key: string) {
        if (key === 'C') {
            this.openCash = '';
        } else if (key === 'DEL') {
            this.openCash = this.openCash.slice(0, -1);
        } else if (key === 'ENTER') {
            // nothing
        } else {
            this.openCash += key;
        }
        await this.service.render();
    }

    public async doOpenBusiness() {
        const today = this.getTodayStr();
        const auth = this.getAuthInfo();
        await wiz.call("open_business", {
            date: today,
            openedBy: auth ? `${auth.id} - ${auth.name}` : '-',
            openingCash: parseInt(this.openCash) || 0,
        });
        localStorage.removeItem('pos-business-day');
        this.showOpeningModal = false;
        await this.service.render();
    }

    // ═══════ 테이블 관련 ═══════
    public getStatusLabel(status: string): string {
        switch (status) {
            case 'occupied': return '사용중';
            case 'reserved': return '예약';
            default: return '빈 테이블';
        }
    }

    public getTableOrderTotal(tableId: number): number {
        const order = this.tableOrders[tableId];
        if (!order) return 0;
        return order.items.reduce((s, i) => s + i.price * i.qty, 0);
    }

    public getTableOrderCount(tableId: number): number {
        const order = this.tableOrders[tableId];
        if (!order) return 0;
        return order.items.reduce((s, i) => s + i.qty, 0);
    }

    public async selectTable(table: any) {
        if (this.moveMode && this.moveSourceTable) {
            if (table.id !== this.moveSourceTable.id) {
                await this.doMoveTable(this.moveSourceTable, table);
            }
            return;
        }
        this.selectedTable = this.selectedTable?.id === table.id ? null : table;
        await this.service.render();
    }

    public async openOrderModal() {
        if (!this.selectedTable) return;
        this.orderTableId = this.selectedTable.id;
        const existing = this.tableOrders[this.orderTableId];
        this.orderCart = existing ? existing.items.map(i => ({ ...i })) : [];
        if (this.menuCategories.length > 0) {
            this.orderCategory = this.menuCategories[0].id;
        }
        this.activeModal = 'order';
        await this.service.render();
    }

    public async selectOrderCategory(catId: string) {
        this.orderCategory = catId;
        await this.service.render();
    }

    public async addToCart(item: any) {
        const desc = item.desc ? ` (${item.desc})` : '';
        const displayName = item.name + desc;
        const existing = this.orderCart.find(c => c.menuId === item.id);
        if (existing) { existing.qty++; } else { this.orderCart.push({ menuId: item.id, name: displayName, price: item.price, qty: 1 }); }
        await this.service.render();
    }

    public async cartQtyChange(idx: number, delta: number) {
        this.orderCart[idx].qty += delta;
        if (this.orderCart[idx].qty <= 0) this.orderCart.splice(idx, 1);
        await this.service.render();
    }

    public async removeCartItem(idx: number) {
        this.orderCart.splice(idx, 1);
        await this.service.render();
    }

    public async saveOrder() {
        if (this.isProcessing) return;
        this.isProcessing = true;
        try {
            if (this.orderCart.length === 0) {
                await wiz.call("save_order", { tableId: this.orderTableId, items: JSON.stringify([]) });
            } else {
                await wiz.call("save_order", { tableId: this.orderTableId, items: JSON.stringify(this.orderCart) });
            }
            await this.loadTables();
            await this.loadOrders();
            if (this.selectedTable) {
                this.selectedTable = this.tables.find(t => t.id === this.selectedTable.id) || null;
            }
            this.activeModal = '';
        } finally {
            this.isProcessing = false;
        }
        await this.service.render();
    }

    public async openPaymentModal() {
        if (!this.selectedTable) return;
        this.paymentTableId = this.selectedTable.id;
        const order = this.tableOrders[this.paymentTableId];
        this.paymentItems = order ? order.items.map(i => ({ ...i })) : [];
        this.paymentMethod = '';
        this.cashReceived = '';
        this.installmentMonths = '0';
        this.discountType = 'none';
        this.discountValue = '';
        this.splitMethod = 'cash';
        this.splitAmount = '';
        this.splitPayments = [];
        this.receiptType = 'none';
        this.receiptNumber = '';
        this.showQrModal = false;
        this.activeModal = 'payment';
        await this.service.render();
    }

    public async paymentQtyChange(idx: number, delta: number) {
        this.paymentItems[idx].qty += delta;
        if (this.paymentItems[idx].qty <= 0) this.paymentItems.splice(idx, 1);
        await this.service.render();
    }

    public async removePaymentItem(idx: number) {
        this.paymentItems.splice(idx, 1);
        await this.service.render();
    }

    public async selectPaymentMethod(method: string) {
        this.paymentMethod = method;
        this.showQrModal = false;
        if (method === 'kakaopay' || method === 'naverpay') {
            this.qrPaymentName = method === 'kakaopay' ? '카카오페이' : '네이버페이';
            this.showQrModal = true;
        }
        await this.service.render();
    }

    private paymentMethodLabel(method: string): string {
        const methodMap: any = { 'card': '카드', 'cash': '현금', 'kakaopay': '카카오페이', 'naverpay': '네이버페이' };
        return methodMap[method] || method;
    }

    public async addSplitPayment() {
        const amount = parseInt(this.splitAmount) || this.splitRemain;
        if (!amount || amount <= 0) return;
        this.splitPayments.push({ method: this.paymentMethodLabel(this.splitMethod), amount });
        this.splitAmount = '';
        await this.service.render();
    }

    public async removeSplitPayment(idx: number) {
        this.splitPayments.splice(idx, 1);
        await this.service.render();
    }

    public async closeQrModal() {
        this.showQrModal = false;
        await this.service.render();
    }

    public async completePayment() {
        if (this.isProcessing) return;
        this.isProcessing = true;
        try {
            let res: any;
            const basePayload: any = {
                tableId: this.paymentTableId,
                items: JSON.stringify(this.paymentItems),
                receiptType: this.receiptType,
                receiptNumber: this.receiptNumber,
                cashReceived: this.cashReceived,
                discountType: this.discountType,
                discountValue: parseInt(this.discountValue) || 0,
            };
            if (this.splitPayments.length > 0) {
                if (this.splitTotal !== this.paymentTotal) {
                    this.lastReceiptMsg = `분할결제 잔액 ${this.formatCurrency(this.paymentTotal - this.splitTotal)}원이 남았습니다.`;
                    this.isProcessing = false;
                    await this.service.render();
                    return;
                }
                res = await wiz.call("split_payment", {
                    ...basePayload,
                    payments: JSON.stringify(this.splitPayments),
                });
            } else if (this.paymentDiscountAmount > 0) {
                res = await wiz.call("complete_payment_with_discount", {
                    ...basePayload,
                    method: this.paymentMethodLabel(this.paymentMethod),
                });
            } else {
                res = await wiz.call("complete_payment", {
                    tableId: this.paymentTableId,
                    method: this.paymentMethodLabel(this.paymentMethod),
                    items: JSON.stringify(this.paymentItems),
                    receiptType: this.receiptType,
                    receiptNumber: this.receiptNumber,
                    cashReceived: this.cashReceived,
                    installmentMonths: this.installmentMonths,
                });
            }
            if (!res || res.code !== 200) {
                this.lastReceiptMsg = res?.data?.message || '결제 처리에 실패했습니다.';
                this.isProcessing = false;
                await this.service.render();
                return;
            }
            if (res?.code === 200 && res.data?.orderId) {
                await this.printPaymentReceipt(res.data.orderId);
            }
            await this.loadTables();
            await this.loadOrders();
            this.selectedTable = null;
            this.showQrModal = false;
            this.activeModal = '';
        } finally {
            this.isProcessing = false;
        }
        await this.service.render();
    }

    public async setCashPreset(amount: number) {
        this.cashReceived = String(amount);
        await this.service.render();
    }

    public async startMoveMode() {
        if (!this.selectedTable) return;
        this.moveMode = true;
        this.moveSourceTable = this.selectedTable;
        await this.service.render();
    }

    // #12 주방 전송
    public async sendToKitchen() {
        if (!this.selectedTable || this.isProcessing) return;
        this.isProcessing = true;
        try {
            await wiz.call("send_to_kitchen", { tableId: this.selectedTable.id });
            this.printKitchenTicket(this.selectedTable.id);
        } finally {
            this.isProcessing = false;
        }
        await this.service.render();
    }

    private printHtml(html: string) {
        const win = window.open('', '_blank', 'width=420,height=640');
        if (!win) return;
        win.document.open();
        win.document.write(html);
        win.document.close();
    }

    private async printPaymentReceipt(orderId: string) {
        let res = await wiz.call("receipt_print", { orderId });
        if (res.code === 200 && res.data.html) {
            this.printHtml(res.data.html);
        }
    }

    public printKitchenTicket(tableId: number) {
        const order = this.tableOrders[tableId];
        if (!order || !order.items || order.items.length === 0) return;
        const table = this.tables.find(t => t.id === tableId);
        const rows = order.items.map((item: any) =>
            `<tr><td>${item.name}</td><td style="text-align:center">${item.qty}</td></tr>`
        ).join('');
        const now = new Date().toLocaleString();
        this.printHtml(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>주방 주문서</title>
<style>body{font-family:Arial,sans-serif;width:300px;margin:0 auto;padding:18px;color:#111}h2{text-align:center;margin:0 0 8px}.line{border-top:1px dashed #111;margin:10px 0}table{width:100%;border-collapse:collapse}td,th{padding:5px;border-bottom:1px solid #ddd;font-size:14px}@media print{body{margin:0;padding:10px}}</style>
</head><body><h2>주방 주문서</h2><div class="line"></div><p>테이블: ${table?.code || tableId}<br>주문시각: ${now}</p><table><thead><tr><th>메뉴</th><th>수량</th></tr></thead><tbody>${rows}</tbody></table><script>window.onload=function(){window.print();}</script></body></html>`);
    }

    public async cancelMoveMode() {
        this.moveMode = false;
        this.moveSourceTable = null;
        await this.service.render();
    }

    private async doMoveTable(source: any, target: any) {
        // #17: 대상 테이블에 기존 주문이 있으면 확인
        let res = await wiz.call("check_merge", { sourceId: source.id, targetId: target.id });
        if (res.code === 200 && res.data.hasExistingOrder) {
            this.mergeTargetTable = target;
            this.confirmMerge = true;
            await this.service.render();
            return;
        }
        await this.executeMoveTable(source, target);
    }

    public async confirmMergeAndMove() {
        if (this.moveSourceTable && this.mergeTargetTable) {
            await this.executeMoveTable(this.moveSourceTable, this.mergeTargetTable);
        }
        this.confirmMerge = false;
        this.mergeTargetTable = null;
        await this.service.render();
    }

    public async cancelMerge() {
        this.confirmMerge = false;
        this.mergeTargetTable = null;
        await this.service.render();
    }

    private async executeMoveTable(source: any, target: any) {
        await wiz.call("move_table", { sourceId: source.id, targetId: target.id });
        await this.loadTables();
        await this.loadOrders();
        this.moveMode = false;
        this.moveSourceTable = null;
        this.selectedTable = this.tables.find(t => t.id === target.id) || null;
        await this.service.render();
    }

    private async handleMenuAction(action: string) {
        if (action === 'orderSearch') {
            await this.loadPaymentHistory();
            this.activeModal = 'orderSearch';
        }
        else if (action === 'lastReceipt') { await this.doLastReceipt(); return; }
        else if (action === 'waitList') {
            await this.loadWaitList();
            this.activeModal = 'waitList';
        }
        else if (action === 'reservation') {
            await this.loadReservations();
            this.activeModal = 'reservation';
        }
        else if (action === 'webInfo') { this.activeModal = 'webInfo'; }
        await this.service.render();
    }

    public async closeModal() { this.activeModal = ''; this.showQrModal = false; await this.service.render(); }
    public goBack() { this.service.href('/pos'); }

    // ─── 주문서 조회 ───
    private async loadPaymentHistory() {
        const today = this.getTodayStr();
        let res = await wiz.call("payment_list", { date: today });
        if (res.code === 200) {
            this.osOrders = (res.data.list || []).map((p: any, i: number) => ({
                orderId: p.orderId,
                posNo: String(i + 1).padStart(3, '0'),
                table: p.tableCode || '-',
                firstTime: (p.paidAt || '').substring(11, 16),
                amount: p.amount,
                type: p.status === 'refunded' ? '환불' : '정상',
                items: p.items,
            }));
        }
    }

    public async osSearch() { await this.loadPaymentHistory(); await this.service.render(); }
    public async osPrint() {
        const selected = this.osOrders[this.osSelectedIdx] || this.osOrders[0];
        if (selected?.orderId) await this.printPaymentReceipt(selected.orderId);
        await this.service.render();
    }

    public async osRefund() {
        const selected = this.osOrders[this.osSelectedIdx];
        if (!selected?.orderId || selected.type === '환불') return;
        const res = await wiz.call("refund_payment", { orderId: selected.orderId, reason: "주문서 조회 환불" });
        this.lastReceiptMsg = res.code === 200 ? '환불 처리되었습니다.' : (res.data?.message || '환불 처리에 실패했습니다.');
        await this.loadPaymentHistory();
        await this.service.render();
    }
    public async osSelect(idx: number) {
        this.osSelectedIdx = idx;
        const o = this.osOrders[idx];
        if (o && o.items) {
            this.osDetails = (Array.isArray(o.items) ? o.items : []).map((item: any, i: number) => ({
                name: item.name, qty: item.qty, round: 1, posNo: o.posNo,
                time: o.firstTime, type: '주문', orderer: '홀',
            }));
        } else {
            this.osDetails = [];
        }
        await this.service.render();
    }

    public async doLastReceipt() {
        const today = this.getTodayStr();
        let res = await wiz.call("payment_list", { date: today });
        if (res.code === 200 && res.data.list && res.data.list.length > 0) {
            await this.printPaymentReceipt(res.data.list[0].orderId);
            this.lastReceiptMsg = '출력되었습니다.';
        } else {
            this.lastReceiptMsg = '출력할 영수증 정보가 없습니다.';
        }
        this.activeModal = 'lastReceipt';
        await this.service.render();
    }

    // ─── 대기접수 ───
    private async loadWaitList() {
        let res = await wiz.call("waitlist_load");
        if (res.code === 200) {
            this.waitListData = (res.data.list || []).map((w: any, i: number) => ({
                ...w, no: i + 1, waitNo: w.wait_no,
                regTime: w.regTime || '', elapsed: w.elapsed || '',
            }));
        }
    }

    public async wlReset() { this.wlName = ''; this.wlPhone = ''; this.wlCount = ''; this.wlNote = ''; await this.service.render(); }

    public async wlAdd() {
        if (!this.wlName) return;
        await wiz.call("waitlist_add", {
            name: this.wlName, phone: this.wlPhone,
            count: parseInt(this.wlCount) || 1, note: this.wlNote,
        });
        await this.loadWaitList();
        this.wlReset();
        await this.service.render();
    }

    public async wlDeleteAll() {
        await wiz.call("waitlist_clear");
        this.waitListData = [];
        this.wlSelectedIdx = -1;
        await this.service.render();
    }

    public async wlSelect(idx: number) {
        this.wlSelectedIdx = idx;
        await this.service.render();
    }

    public async wlDelete() {
        const row = this.waitListData[this.wlSelectedIdx];
        if (row?.id) {
            await wiz.call("waitlist_delete", { id: row.id });
            await this.loadWaitList();
            this.wlSelectedIdx = -1;
        }
        await this.service.render();
    }

    public async wlPrint() {
        const rows = this.waitListData.map((w: any) => `<tr><td>${w.waitNo}</td><td>${w.name}</td><td>${w.count}</td><td>${w.regTime}</td></tr>`).join('');
        this.printHtml(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>대기명단</title><style>body{font-family:Arial,sans-serif;padding:18px;color:#111}table{width:100%;border-collapse:collapse}td,th{padding:6px;border-bottom:1px solid #ddd}</style></head><body><h2>대기명단</h2><table><thead><tr><th>번호</th><th>성명</th><th>인원</th><th>접수</th></tr></thead><tbody>${rows}</tbody></table><script>window.onload=function(){window.print();}</script></body></html>`);
        await this.service.render();
    }
    public wlOnKey(key: string) { if (key === 'C') this.wlKeypad = ''; else if (key === 'DEL') this.wlKeypad = this.wlKeypad.slice(0, -1); else if (key !== 'ENTER') this.wlKeypad += key; this.service.render(); }

    // ─── 예약관리 ───
    private async loadReservations() {
        let res = await wiz.call("reservation_load");
        if (res.code === 200) {
            this.rvList = (res.data.list || []).map((r: any, i: number) => ({
                ...r, no: i + 1, table: r.table_code || '',
            }));
        }
    }

    public async rvSelect(idx: number) {
        this.rvSelectedIdx = idx; const r = this.rvList[idx];
        this.rvDate = r.date; this.rvTime = r.time; this.rvName = r.name;
        this.rvPhone = r.phone; this.rvCount = String(r.count); this.rvTable = r.table; this.rvMemo = r.memo;
        await this.service.render();
    }
    public async rvNew() { this.rvDate = ''; this.rvTime = ''; this.rvName = ''; this.rvPhone = ''; this.rvCount = ''; this.rvTable = ''; this.rvMemo = ''; this.rvSelectedIdx = -1; await this.service.render(); }
    public async rvCancel() {
        if (this.rvSelectedIdx >= 0) {
            const r = this.rvList[this.rvSelectedIdx];
            if (r && r.id) {
                await wiz.call("reservation_cancel", { id: r.id });
                await this.loadReservations();
            }
        }
        await this.service.render();
    }
    public async rvSave() {
        const auth = this.getAuthInfo();
        await wiz.call("reservation_save", {
            id: this.rvSelectedIdx >= 0 ? this.rvList[this.rvSelectedIdx]?.id || '' : '',
            name: this.rvName, phone: this.rvPhone, date: this.rvDate,
            time: this.rvTime, count: parseInt(this.rvCount) || 1,
            memo: this.rvMemo, staff: auth ? auth.name : '',
            tableCode: this.rvTable, type: '예약',
        });
        await this.loadReservations();
        this.rvNew();
        await this.service.render();
    }
    public async rvPrintDetail() {
        const r = this.rvList[this.rvSelectedIdx];
        if (!r) return;
        this.printHtml(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>예약내역</title><style>body{font-family:Arial,sans-serif;width:320px;margin:0 auto;padding:18px;color:#111}.line{border-top:1px dashed #111;margin:10px 0}p{line-height:1.7}</style></head><body><h2>예약내역</h2><div class="line"></div><p>예약자: ${r.name}<br>연락처: ${r.phone}<br>일시: ${r.date} ${r.time}<br>인원: ${r.count}<br>테이블: ${r.table || '-'}</p><p>메모: ${r.memo || ''}</p><script>window.onload=function(){window.print();}</script></body></html>`);
        await this.service.render();
    }

    public async rvPrintStatus() {
        const rows = this.rvList.map((r: any) => `<tr><td>${r.date}</td><td>${r.time}</td><td>${r.name}</td><td>${r.count}</td><td>${r.type}</td></tr>`).join('');
        this.printHtml(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>예약현황</title><style>body{font-family:Arial,sans-serif;padding:18px;color:#111}table{width:100%;border-collapse:collapse}td,th{padding:6px;border-bottom:1px solid #ddd}</style></head><body><h2>예약현황</h2><table><thead><tr><th>일자</th><th>시간</th><th>예약자</th><th>인원</th><th>구분</th></tr></thead><tbody>${rows}</tbody></table><script>window.onload=function(){window.print();}</script></body></html>`);
        await this.service.render();
    }
    public rvOnKey(key: string) { if (key === 'C') this.rvKeypad = ''; else if (key === 'DEL') this.rvKeypad = this.rvKeypad.slice(0, -1); else if (key !== 'ENTER') this.rvKeypad += key; this.service.render(); }

    public formatCurrency(v: number): string { return (v || 0).toLocaleString(); }
}

export default PagePosSalesComponent;